export const SET_DEFAULT_MESSAGE = "@KNOWLEDGE/SET_DEFAULT_MESSAGE";
